import Box from '@mui/material/Box';
import Radio from "@mui/material/Radio";
import { observer, } from 'mobx-react-lite';
import React, { useContext, useEffect, useState } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { messageContext } from "../../stores/messages/messageContext";
import { userContext } from "../../stores/users/userContext";
import { getUserTranscriptVideosUrl } from "../constants";
import HasVideo from "../grid/hasVideo";
import Header from "../header/header";
import { downloadedHeader } from "../header/headerConstants";
import Loading from "../loading/loading";
import { handleSort } from "../../utils";
import './downloaded.css';


const Downloaded = () => {
    const userStore = useContext(userContext)
    const message = useContext(messageContext)
    const [userDownloaded, setUserDownloaded] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [, forceUpdate] = useState({});

    const [header, setHeader] = useState(downloadedHeader)

    const radioChange = (event, data) => {
        console.log('Selection changed to:', {
            transcriptId: data['id'],
            title: data['title']
        });

        // Set transcript selection using the transcript ID directly
        userStore.setUserTranscript(
            data['id'],           // transcript id (for UI selection)
            data['title'],        // title
            data['id'],           // transcript id (for API calls)
            0                     // size (not provided by transcript endpoint)
        );

        console.log('Stored transcript ID:', userStore.getUserTranscriptId());
        // Force component re-render to update radio buttons
        forceUpdate({});
    }

    useEffect(() => {
        setLoading(true)
        fetch(`${getUserTranscriptVideosUrl}${userStore.getToken()}/`)
            .then(res => res.json())
            .then(
                (result) => {
                    setLoading(false);
                    if (result.length === 0) {
                        message.setMessage("You haven't downloaded or uploaded any videos yet, but feel free to do so using options menu.", 'info', 10000)

                    } else {
                        setUserDownloaded(result);
                        // Set initial selection using first transcript
                        userStore.setUserTranscript(result[0]['id'], result[0]['title'], result[0]['id'], 0);
                    }
                },
                (error) => {
                    setError(error);
                    setLoading(false);
                }
            )
    }, [])

    const onSortClick = (index) => {
        handleSort(userDownloaded, header, index, setUserDownloaded, setHeader);
    }

    const itemContentDownloaded = (item, data) => {
        // Use the item index to get the correct row data
        const rowData = userDownloaded[item];
        // Force observation of the store by accessing it in render - use transcript ID for selection
        const currentTranscriptId = userStore.getUserTranscriptId();

        return (
            <>
                <td>
                    <Radio
                        style={{ margin: 10, fontSize: 15 }}
                        value={rowData['id']}
                        checked={currentTranscriptId === rowData['id']}
                        onChange={(event) => {
                            radioChange(event, rowData)
                        }}
                        name="radio-group"
                    />
                </td>
                <td>{rowData['title']}</td>
                <td>
                    <HasVideo data={rowData} />
                </td>
                <td>Transcribed</td>
                <td>{rowData['created_at']}</td>

            </>
        )
    }

    if (loading) return <Loading />;
    if (error) message.setMessage(`Error:${error}`, 'error')

    return (
        <Box sx={{
            background: 'background.paper',
            width: '100%',
            height: '100vh',
            margin: '0 auto',
            paddingTop: { xs: '70px', sm: '75px', md: '61px' },
            paddingLeft: { xs: 1, sm: 2, md: 0 },
            paddingRight: { xs: 1, sm: 2, md: 0 },
            paddingBottom: { xs: 1, sm: 2, md: 3 },
            boxSizing: 'border-box',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        }}>

            <TableVirtuoso data={userDownloaded}
                style={{
                    height: '100%',
                    width: '100%',
                    maxWidth: '100%',
                    flex: 1
                }}
                components={{
                    Table: (props) => (
                        <table
                            {...props}
                            className="downloaded-table"
                            style={{
                                ...props.style,
                                tableLayout: 'fixed',
                                width: '100%',
                                maxWidth: '100%',
                                borderCollapse: 'collapse'
                            }}
                        />
                    ),
                    TableRow: React.forwardRef((props, ref) => {
                        // Remove the item prop to prevent [object Object] in HTML
                        const { item, ...cleanProps } = props;
                        return (
                            <tr
                                {...cleanProps}
                                ref={ref}
                                className={`${props.className || ''} responsive-table-row`}
                            />
                        );
                    })
                }}
                fixedHeaderContent={() => <Header header={header} onClick={onSortClick} />}
                itemContent={itemContentDownloaded}
            />
        </Box>
    )
}

export default observer(Downloaded)